import React, {useState, useEffect} from "react";
import { Main, Content } from '../../../components/Layout'
import { Col, Row } from 'react-bootstrap';
import IcEditar from '../../../components/Svg/IcEditar';
import api from '../../../services/api';
import Accordion from "../../../components/Accordion";
import Checkbox from '../../../components/Checkbox';
import styleButton from '../../../components/Button/Button.module.css'
import Loading from '../../../components/Loading';
import { toast } from 'react-toastify';
import useWrapper from "../../../hooks/useWrapper";

export default function AdminEvents() {
  const { setbreadcrumb, config } = useWrapper();

  const [loadingPage, setLoadingPage] = useState(true);
  const [reload, setreload] = useState(false);
  const [categories, setcategories] = useState();
  useEffect(() => {
    api.get('categories?only_attendance=0', config)
    .then(resp => {
      let _categories = resp.data.data;
      _categories = _categories.map(__category => {
        let _events = __category.event;
        _events.sort((a, b) => {
          return a.name.localeCompare(b.name);
        })
        return {
          ...__category,
          event: _events
        }
      })
      _categories.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      setcategories(_categories);
      setLoadingPage(false);
    })
  }, [reload]);

  const createCategory = e => {
    if(!e.name) {
      setreload(!reload);
    }
    else if(!e.id) {
      api.post("categories", {
        name: e.name,
        only_attendance: e.only_attendance,
        main_events: e.main_events
      }, config)
      .then(() => {
        toast.success(`Nova Categoria "${e.name}" criada com sucesso!`);
        setreload(!reload);
      })
    }
    else {
      api.put(`categories/${e.id}`, {
        name: e.name,
        only_attendance: e.only_attendance,
        main_events: e.main_events
      }, config)
      .then(() => {
        toast.success(`Categoria "${e.name}" editada com sucesso!`);
        setreload(!reload);
      })
    }
  }

  const createEvent = e => {
    if(!e.name) {
      setreload(!reload);
    }
    else if(!e.id) {
      api.post("events", {
        name: e.name,
        id: e.id,
        category_id: e.category_id
      }, config)
      .then(() => {
        toast.success(`Novo Evento "${e.name}" criado com sucesso!`);
        setreload(!reload);
      })
    }
    else {
      api.put(`events/${e.id}`, {
        name: e.name,
        id: e.id,
        category_id: e.category_id
      }, config)
      .then(() => {
        toast.success(`Evento "${e.name}" editado com sucesso!`);
        setreload(!reload);
      })
    }
  }

  useEffect(() => {
    setbreadcrumb([
      { label: "Administrativo" },
    ])
  }, []);

  return (
    <Main>
      <Content>
        {!loadingPage ? (
          <>
            <Row>
              <Col>
                <h2 className="mini-title">Gerenciar Eventos & Solenidades</h2>
                <p className="small-label font-italic mb-3">Escolha as solenidades que você vai ofertar aos seus formandos. Nós fornecemos algumas opções padronizadas, mas você pode adicionar novas categorias que se adequem a sua empresa!</p>
                <Accordion>
                  {categories && categories.map((e, i) => (
                    <Accordion.Item eventKey={i + 1}>
                      <Accordion.Header
                        eventKey={!e.editable ? i + 1 : null}
                        style={e.editable ? {borderColor: "var(--color-primary"} : {}}
                      >
                        <div
                          className={styleButton.input_button_list}
                          data-edit={e.editable}
                          style={{border: "none", padding: "0", height: "auto"}}
                        >
                          {/* {!!e.id && (
                            <Accordion.Extras className="mr-2">
                              <label style={{cursor: "pointer"}} colorScheme="primary">
                                <Checkbox 
                                  colorScheme="primary"
                                  checked={e.main_events} 
                                  onChange={value => {
                                    let _categories = [...categories];
                                    categories[i].main_events = value.target.checked;
                                    setcategories(_categories);
                                    createCategory({
                                      id: e.id,
                                      name: e.name,
                                      only_attendance: e.only_attendance,
                                      main_events: e.main_events
                                    })
                                  }}
                                />
                                <span className="ml-1">Oficial</span>
                              </label>
                            </Accordion.Extras>
                          )} */}
                          <label style={{cursor: "pointer"}}>
                            <input
                              type="text"
                              placeholder={`Novo Categoria`}
                              value={e.name}
                              disabled={!e.editable}
                              autoFocus
                              style={!e.editable ? {pointerEvents: "none"} : {}}
                              onChange={ev => {
                                let _categories = [...categories];
                                _categories[i].name = ev.target.value;
                                setcategories(_categories);
                              }}
                              onBlur={() => {
                                let _categories = [...categories];
                                createCategory({
                                  id: e.id,
                                  name: e.name,
                                  only_attendance: e.only_attendance,
                                  main_events: e.main_events
                                })
                              _categories[i].editable = false;
                              setcategories(_categories);
                              }}
                              onKeyDown={ev => {
                                if(ev.keyCode === 13 || ev.keyCode === 27) {
                                  ev.target.blur();
                                }
                              }}
                            />
                            <button
                              type="button"
                              className="simple-ico mr-2"
                              onClick={ev => {
                                ev.stopPropagation();
                                let _categories = [...categories];
                                _categories[i].editable = true;
                                setcategories(_categories);
                              }}
                            >
                              {!e.editable && (
                                <IcEditar />
                              )}
                            </button>
                          </label>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Row style={{marginTop: "-1rem"}}>
                          {e.event.map((e2, i2) => (
                            <Col sm={6} className="mt-3">
                              <div className={styleButton.input_button_list} data-edit={e2.editable}>
                                <label>
                                  <input
                                    type="text"
                                    placeholder={`Novo Evento`}
                                    value={e2.name}
                                    disabled={!e2.editable}
                                    autoFocus
                                    onChange={ev => {
                                      let _categories = [...categories];
                                      _categories[i].event[i2].name = ev.target.value;
                                      setcategories(_categories);
                                    }}
                                    onBlur={() => {
                                      let _categories = [...categories];
                                      createEvent({
                                        id: e2.id,
                                        name: e2.name,
                                        category_id: e.id
                                      })
                                      setTimeout(function() {
                                        _categories[i].event[i2].editable = false;
                                        setcategories(_categories);
                                      }, 100);
                                    }}
                                    onKeyPress={ev => {
                                      if(ev.charCode === 13) {
                                        ev.target.blur();
                                      }
                                    }}
                                  />
                                    <button
                                      type="button"
                                      className="simple-ico"
                                      onClick={() => {
                                        let _categories = [...categories];
                                        _categories[i].event[i2].editable = true;
                                        setcategories(_categories);
                                      }}
                                    >
                                      {!e2.editable && (
                                        <IcEditar />
                                      )}
                                    </button>
                                </label>
                              </div>
                            </Col>
                          ))}
                          <Col sm={12}>
                            <button
                              className={`mt-3 ${styleButton.button_add}`}
                              colorScheme="grey"
                              type="button"
                              onClick={() => {
                                let _categories = [...categories];
                                _categories[i].event.push({
                                  editable: true,
                                  id: null,
                                  name: ""
                                })
                                setcategories(_categories);
                              }}
                            >
                              <span>Adicionar Evento ({e.name})</span>
                            </button>
                          </Col>
                        </Row>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              
                <button
                  className={`mt-3 ${styleButton.button_add}`}
                  type="button"
                  colorScheme="primary"
                  onClick={() => {
                    let _categories = [...categories];
                    _categories.push({
                      editable: true,
                      id: null,
                      name: "",
                      event: [],
                      resource: [],
                      only_attendance: 0,
                      main_events: 0
                    });
                    setcategories(_categories);
                  }}
                >
                  <span>Adicionar Categoria</span>
                </button>
              </Col>
            </Row>
            {/* <h2 className="mini-title mb-1 mt-3">Categorias</h2> */}
          </>
        ):(
          <Loading />
        )}
      </Content>
    </Main>
  );
}